/* ─────────────────── CSS-in-JS styles ของหน้า API Docs ─────────────────── */
export const apiDocsStyles = `
  @keyframes api-float {
    0%, 100% { transform: translateY(0px) rotate(0deg); opacity: 0.4; }
    50% { transform: translateY(-20px) rotate(180deg); opacity: 0.8; }
  }
  @keyframes api-glow-pulse {
    0%, 100% { opacity: 0.3; }
    50% { opacity: 0.6; }
  }
  @keyframes api-slide-in {
    from { opacity: 0; transform: translateX(-12px); }
    to { opacity: 1; transform: translateX(0); }
  }
  @keyframes api-fade-up {
    from { opacity: 0; transform: translateY(16px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes api-shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
  .api-docs-hero-particle {
    position: absolute;
    border-radius: 50%;
    animation: api-float linear infinite;
  }
  .api-docs-sidebar-item {
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .api-docs-sidebar-item:hover {
    transform: translateX(4px);
  }
  .api-docs-content-enter {
    animation: api-fade-up 0.35s ease-out;
  }
  .api-docs-code-block {
    position: relative;
    border: 1px solid rgba(255,255,255,0.06);
  }
  .api-docs-code-block::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(99,102,241,0.4), transparent);
  }
  .api-docs-table tr:hover td {
    background: rgba(99,102,241,0.04);
  }
  .api-docs-glow-card {
    position: relative;
    overflow: hidden;
  }
  .api-docs-glow-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(99,102,241,0.06) 0%, transparent 70%);
    opacity: 0;
    transition: opacity 0.4s;
    pointer-events: none;
  }
  .api-docs-glow-card:hover::before {
    opacity: 1;
  }
  .api-docs-method-badge {
    font-family: 'SF Mono', 'Fira Code', 'Cascadia Code', monospace;
    letter-spacing: 0.05em;
    font-weight: 700;
    font-size: 0.7rem;
    padding: 0.25rem 0.75rem;
    border-radius: 6px;
    text-transform: uppercase;
  }
  .api-docs-shimmer {
    background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.03) 50%, transparent 100%);
    background-size: 200% 100%;
    animation: api-shimmer 3s ease-in-out infinite;
  }
  @keyframes api-pulse-border {
    0%, 100% { border-color: rgba(99,102,241,0.2); }
    50% { border-color: rgba(99,102,241,0.5); }
  }
  .api-playground-active {
    animation: api-pulse-border 2s ease-in-out infinite;
  }
`;
